/**
 * The link an assistant hands a person (KPE-047, KPR-1439):
 * `/discover/<key>?install=1&collection=<id>&newCollection=<name>&addOns=a,b&examples=1`.
 * It opens Add to collection with those choices made; it never adds anything
 * itself. This module only reads the query. Whether each value still fits
 * (a collection the person manages, an add-on the package has) is decided in
 * the dialog, which knows both.
 */

const MAX_NAME = 100;

/** The link's choices from a URLSearchParams; `install` is false for any link without `install=1`. */
export function parseInstallLink(params) {
	const get = key => {
		const value = params.get(key);
		return typeof value === 'string' ? value.trim() : '';
	};
	const addOns = [...new Set(get('addOns').split(',').map(key => key.trim()).filter(Boolean))];
	const examples = get('examples');
	return {
		install: get('install') === '1',
		collection: get('collection') || null,
		newCollection: get('newCollection').slice(0, MAX_NAME) || null,
		addOns,
		// true / false when the link says; null leaves the dialog's own default.
		examples: examples === '1' ? true : examples === '0' ? false : null,
	};
}

/** Does the link carry any choice the dialog should apply? */
export function hasInstallChoices(link) {
	return Boolean(link && (link.collection || link.newCollection || link.addOns.length || link.examples !== null));
}

/** "a, b and c" for the dropped line. */
function inWords(parts) {
	if (parts.length < 2) return parts.join('');
	return `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}

/** The one line the dialog shows for what it could not use; '' when everything fit. */
export function droppedFromLinkLine(pieces) {
	const list = (pieces || []).filter(Boolean);
	if (!list.length) return '';
	return `Not used from the link: ${inWords(list)}.`;
}
